// import axios from "axios";
// import { API } from "../config/config";
// import Cookie from "js-cookie";
// import { getUserDetailsInLocalStorage } from "./UserDetails";
// import { getLanguage } from "./LocalizationHelper";

// const apiClient = axios.create({
//   baseURL: API,
// });

// apiClient.interceptors.request.use(
//   (config) => {
//     // Add 'lang' as a query parameter from localStorage
//     const lang = getLanguage();  // Get 'lang' from localStorage

//     if (lang) {
//       const separator = config.url.includes('?') ? '&' : '?'; // Check if the URL already has query params
//       config.url = `${config.url}${separator}lang=${lang}`;  // Append the 'lang' query param
//     }

//     config.withCredentials = true;
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// let retryCounter = 0;

// apiClient.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     const user = getUserDetailsInLocalStorage();
//     const role = user?.role || "";

//     if(error.response.status === 402) { // payment required, subscription is not active
//       window.location.href = "/dashboard/inactive-subscription"
//       return;
//     }

//     if ((error.response.status === 401 || error.response.status === 403) && !originalRequest._retry) {
//       originalRequest._retry = true;

//       retryCounter+=1;

//       if(retryCounter > 3) {
//         Cookie.remove("restroprosaas__authenticated");
//         if(role == "superadmin") {
//           window.location.href = "/superadmin";
//         } else {
//           window.location.href = "/login";
//         }
//         return;
//       }

//       try {
//         let res;
//         if(role == "superadmin") {
//           res = await apiClient.post("/superadmin/refresh-token")
//         } else {
//           res = await apiClient.post("/auth/refresh-token")
//         }

//         const data = res.data;

//         if(res.status == 401 || res.status == 403) {
//           if(role == "superadmin") {
//             window.location.href = "/superadmin";
//           } else {
//             window.location.href = "/login";
//           }
//           return;
//         }
//         retryCounter = 0;
//         return apiClient(originalRequest);
//       } catch (error) {
//         // Handle refresh token error (e.g., redirect to login)
//         console.error(error);
//         if(role == "superadmin") {
//           window.location.href = "/superadmin";
//         } else {
//           window.location.href = "/login";
//         }
//         return Promise.reject(error);
//       }
//     } else {
//       return Promise.reject(error);
//     }
//   }
// );

// export default apiClient;

// // helpers/ApiClient.js
// // Axios-based ApiClient with cookie support + refresh-on-401 (single retry)

// // import axios from "axios";

// // const baseURL = process.env.REACT_APP_API_BASE || ""; // set your API base URL if needed
// // const REFRESH_URL = "/auth/refresh-token"; // must match backend route

// // const api = axios.create({
// //   baseURL,
// //   timeout: 30000,
// //   withCredentials: true, // IMPORTANT: send HttpOnly cookies
// //   headers: {
// //     "Content-Type": "application/json",
// //     Accept: "application/json",
// //   },
// // });

// // // Prevent infinite loops: track refresh in progress and failed refresh redirect
// // let isRefreshing = false;
// // let failedQueue = [];
// // let alreadyRedirectedToLogin = false;

// // const processQueue = (error, token = null) => {
// //   failedQueue.forEach((prom) => {
// //     if (error) prom.reject(error);
// //     else prom.resolve(token);
// //   });
// //   failedQueue = [];
// // };

// // api.interceptors.response.use(
// //   (response) => response,
// //   async (error) => {
// //     const originalRequest = error.config;

// //     // If no response or not 401, just reject
// //     if (!error.response || error.response.status !== 401) {
// //       return Promise.reject(error);
// //     }

// //     // If we've already retried this request, don't retry again
// //     if (originalRequest._retry) {
// //       // final fallback: redirect to login (once)
// //       if (!alreadyRedirectedToLogin) {
// //         alreadyRedirectedToLogin = true;
// //         window.location.href = "/login";
// //       }
// //       return Promise.reject(error);
// //     }

// //     // Mark original request as retried
// //     originalRequest._retry = true;

// //     if (isRefreshing) {
// //       // queue the request, will be resolved when refresh finishes
// //       return new Promise(function (resolve, reject) {
// //         failedQueue.push({ resolve, reject });
// //       })
// //         .then(() => api(originalRequest))
// //         .catch((err) => Promise.reject(err));
// //     }

// //     isRefreshing = true;

// //     try {
// //       // call refresh endpoint (cookies will be sent thanks to withCredentials)
// //       const refreshResp = await api.post(REFRESH_URL);

// //       // If refreshResp is OK, process queued requests
// //       processQueue(null, true);
// //       isRefreshing = false;

// //       // retry original request
// //       return api(originalRequest);
// //     } catch (refreshError) {
// //       processQueue(refreshError, null);
// //       isRefreshing = false;

// //       // refresh failed -> clear cookies (optional) and redirect once to login
// //       try {
// //         // Attempt to hit signout endpoint to clear server side (optional)
// //         await api.post("/auth/signout").catch(() => {});
// //       } catch (e) {
// //         /* ignore */
// //       }

// //       if (!alreadyRedirectedToLogin) {
// //         alreadyRedirectedToLogin = true;
// //         window.location.href = "/login";
// //       }

// //       return Promise.reject(refreshError);
// //     }
// //   }
// // );

// // // Convenience wrappers used by your POS code (they expect `.get/.post` returning data)
// // const ApiClient = {
// //   get: async (url, config = {}) => {
// //     const resp = await api.get(url, { ...config });
// //     return resp.data;
// //   },
// //   post: async (url, body = {}, config = {}) => {
// //     const resp = await api.post(url, body, { ...config });
// //     return resp.data;
// //   },
// //   put: async (url, body = {}, config = {}) => {
// //     const resp = await api.put(url, body, { ...config });
// //     return resp.data;
// //   },
// //   delete: async (url, config = {}) => {
// //     const resp = await api.delete(url, { ...config });
// //     return resp.data;
// //   },
// //   rawInstance: api, // in case you need low-level access
// // };

// // export default ApiClient;


// helpers/ApiClient.js
// src/utils/apiClient.js
import axios from "axios";
import { API, getApiBaseUrl, getSyncMode, isElectronApp } from "../config/config";
import {
  getUserDetailsInLocalStorage,
  clearUserDetailsInLocalStorage,
} from "./UserDetails";
import { getLanguage } from "./LocalizationHelper";

/**
 * Helper: set user details into localStorage
 * If you already have an equivalent function, use that instead.
 */
const setUserDetailsInLocalStorage = (obj) => {
  try {
    localStorage.setItem("userDetails", JSON.stringify(obj || {}));
  } catch (e) {
    console.warn("setUserDetailsInLocalStorage error", e);
  }
};

const apiClient = axios.create({
  baseURL: API,
  withCredentials: true, // required if refresh uses cookies
});

// A separate axios instance WITHOUT the response interceptor to call the refresh endpoint.
// This avoids recursive interceptor calls and makes refresh behavior reliable.
const refreshClient = axios.create({
  baseURL: API,
  withCredentials: true,
  // no interceptors here
});

refreshClient.interceptors.request.use((config) => {
  config.baseURL = getApiBaseUrl();
  return config;
});

// State for refresh queue
let isRefreshing = false;
let refreshPromise = null; // promise that resolves when refresh completes
let requestQueue = []; // queued { resolve, reject, originalRequest }

// request interceptor: add lang param & dynamic base URL
apiClient.interceptors.request.use(
  (config) => {
    config.baseURL = getApiBaseUrl();

    const lang = getLanguage();
    if (lang) {
      const separator = (config.url || "").includes("?") ? "&" : "?";
      config.url = `${config.url}${separator}lang=${lang}`;
    }

    // Add Authorization header if you store access token and prefer header auth (optional)
    const user = getUserDetailsInLocalStorage();
    const token = user?.token;
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Multi-branch: Attach active branch id if selected
    const activeBranchId = localStorage.getItem("active_branch_id");
    if (activeBranchId) {
      config.headers = config.headers || {};
      config.headers["x-branch-id"] = activeBranchId;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Helper to process queued requests after refresh success/failure
const processQueue = (error, newToken = null) => {
  requestQueue.forEach(({ resolve, reject, originalRequest }) => {
    if (error) {
      reject(error);
    } else {
      // update originalRequest headers with new token if present
      if (newToken) {
        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
      }
      resolve(apiClient(originalRequest));
    }
  });
  requestQueue = [];
};

// response interceptor
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    // network error (no response)
    if (!error?.response) {
      console.error("Network error:", error);
      return Promise.reject(error);
    }

    const status = error.response.status;
    const originalRequest = error.config;
    console.error(`[ApiClient ERR] ${originalRequest?.method?.toUpperCase()} ${originalRequest?.baseURL || ''}${originalRequest?.url} -> Status ${status}:`, error.response?.data);

    // 402: handle inactive subscription (keep existing behavior)
    if (status === 402) {
      window.location.href = "/dashboard/inactive-subscription";
      return Promise.reject(error);
    }

    // Only try refresh for 401 or 403
    if (status === 401) {
      const user = getUserDetailsInLocalStorage();
      const role = user?.role || "";
      const reqUrl = originalRequest?.url || "";

      // If this was a signin/login attempt or signout, don't trigger auto-refresh/logout redirect
      if (reqUrl.includes("/signin") || reqUrl.includes("/signout") || reqUrl.includes("/login")) {
        return Promise.reject(error);
      }

      // If the original request explicitly opted out of retrying (flag)
      if (originalRequest._retry) {
        // already retried and still 401, session has definitely expired -> logout
        clearAllAuthData(role);
        return Promise.reject(error);
      }

      // If a refresh is already in progress, queue the request and return a promise
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          requestQueue.push({ resolve, reject, originalRequest });
        });
      }

      // Start refresh flow
      isRefreshing = true;
      originalRequest._retry = true;

      // Choose endpoint depending on role
      const endpoint = role === "superadmin" ? "/superadmin/refresh-token" : "/auth/refresh-token";

      try {
        // Call the refresh endpoint using refreshClient (no interceptors)
        refreshPromise = refreshClient.post(endpoint, null);

        const res = await refreshPromise;

        // assume the response contains new access token in res.data.accessToken
        if (res && res.status >= 200 && res.status < 300) {
          const newAccessToken = res.data?.accessToken;
          if (newAccessToken) {
            const current = getUserDetailsInLocalStorage() || {};
            const updated = {
              ...current,
              token: newAccessToken,
              ...(res.data?.user ? {
                scope: res.data.user.scope,
                enabled_modules: res.data.user.enabled_modules,
                name: res.data.user.name,
                role: res.data.user.role
              } : {})
            };
            setUserDetailsInLocalStorage(updated);
            try {
              window.dispatchEvent(new Event("auth_state_changed"));
            } catch (e) {}

            // update Authorization header for future requests
            apiClient.defaults.headers.common.Authorization = `Bearer ${newAccessToken}`;

            // process queued requests with new token
            processQueue(null, newAccessToken);

            // retry original request with new token
            return apiClient({ ...originalRequest, headers: { ...originalRequest.headers, Authorization: `Bearer ${newAccessToken}` } });
          } else {
            // If server returned 200 but no token, treat as failure
            throw new Error("refresh succeeded but no accessToken in response");
          }
        } else {
          throw new Error("refresh failed");
        }
      } catch (refreshError) {
        console.error("Refresh token error (Token expired):", refreshError);
        // clear stored auth and queued requests, then redirect to login
        processQueue(refreshError, null);
        clearAllAuthData(role);
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
        refreshPromise = null;
      }
    }

    // other errors: just reject
    return Promise.reject(error);
  }
);

// CLEANUP: Call backend logout to clear httpOnly cookies and redirect
export async function clearAllAuthData(role) {
  console.log("Token expired: Clearing auth data and redirecting to login...");
  clearUserDetailsInLocalStorage();
  try {
    sessionStorage.clear();
  } catch (_) {}

  try {
    // This will clear httpOnly cookies on server
    await axios.post(
      `${API}/${role === "superadmin" ? "superadmin" : "auth"}/signout`,
      {},
      { withCredentials: true }
    );
  } catch (err) {
    console.warn("Logout API failed, proceeding...", err);
  } finally {
    const target = role === "superadmin" ? "/superadmin" : "/login";
    if (window.location.pathname !== target && !window.location.pathname.startsWith("/login")) {
      window.location.href = target;
    }
  }
}

export default apiClient;
